import React, { createContext, type ReactElement } from "react";
import * as RadixAccordion from "@radix-ui/react-accordion";
import { Icon } from "@sproutsocial/seeds-react-icon";
import { type TypeAccordionProps } from "./AccordionTypes";

export const AccordionContext = createContext<{
  triggerIcon: ReactElement | null;
  triggerPosition: string;
  styled: boolean;
}>({
  triggerIcon: null,
  triggerPosition: "",
  styled: false,
});

export const Accordion = ({
  children,
  collapsible,
  defaultValue = ["item-0"],
  triggerPosition = "right",
  triggerIcon = <Icon className="triggerIcon" name="chevron-down-outline" />,
  type = "multiple",
  styled = true,
  value,
  onValueChange,
}: TypeAccordionProps) => {
  const contextValue = {
    triggerIcon: React.isValidElement(triggerIcon) ? triggerIcon : null,
    triggerPosition,
    styled,
  };

  if (type === "single") {
    // Determine if controlled or uncontrolled
    const isControlled = value !== undefined;

    return (
      <RadixAccordion.Root
        type="single"
        value={
          isControlled ? (Array.isArray(value) ? value[0] : value) : undefined
        }
        defaultValue={
          !isControlled && defaultValue
            ? Array.isArray(defaultValue)
              ? defaultValue[0]
              : defaultValue
            : undefined
        }
        onValueChange={onValueChange as ((value: string) => void) | undefined}
        collapsible={collapsible}
      >
        <AccordionContext.Provider value={contextValue}>
          {children}
        </AccordionContext.Provider>
      </RadixAccordion.Root>
    );
  }

  // Multiple mode
  const isControlled = value !== undefined;

  return (
    <RadixAccordion.Root
      type="multiple"
      value={
        isControlled ? (Array.isArray(value) ? value : [value]) : undefined
      }
      defaultValue={
        !isControlled && defaultValue
          ? Array.isArray(defaultValue)
            ? defaultValue
            : [defaultValue]
          : undefined
      }
      onValueChange={onValueChange as ((value: string[]) => void) | undefined}
    >
      <AccordionContext.Provider value={contextValue}>
        {children}
      </AccordionContext.Provider>
    </RadixAccordion.Root>
  );
};
